import { Box } from "@mui/material";
import type { FC } from "react";
import type { ImageDTO } from "./CardImage";
import { ImageBox } from "./CardImage";

interface Props {
  readonly images: ImageDTO[];
}

export const ImageCarousel: FC<Props> = ({ images }: Props) => {
  const index = 0;
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: 3,
        overflow: "hidden",
        mb: 4,
        height: { xs: 300, sm: 400, md: 450 },
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      }}
    >
      <ImageBox image={images[index]} onClick={null} sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
    </Box>
  );
};
